import { Account } from './iam.types';

/* eslint-disable */
export const account: Account = {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    email : 'hughes.brian@company.com',
    username: 'hughes.brian@company.com',
    user :{
        name  : 'Brian',
        surname: 'Hughes',
        status: '',
        avatar: 'public/images/avatars/brian-hughes.jpg',
        mobile: '',
        langId: '',
        password: '',
        rememberToken: '',
        meta: {},
    },
    scopes: [],
    isActive: true,
    clientId: '',
    dApplicationCodes: [],
    dPermissions: {
        all: [],
    },
    dTenants: [],
    meta: {},
    createdAt: '',
    updatedAt: '',
};
